<template>
  <div class="image-uploader">
    <!-- Trigger -->
    <button class="btn-upload" @click="showModal = !showModal">
      Upload Image
    </button>

    <!-- Preview -->
    <!-- Preview -->
    <div class="preview-list w-100"  > 
      <div class="position-relative image-preview" v-for="(img, index) in previews" :key="index"> 
        <img 
        title="Lihat Gambar Produk" @click="openImage(img)" class="preview" :src="img" />
        <button  class="remove-image" @click="remove(index)">×</button>
      </div>
    </div>
    <!-- Modal (NO TELEPORT) -->
    <upload-modal
      v-if="showModal"
      :value="value"
      :limit="limit"
      @input="updateValue"
      @close="closeModal"
    />
  </div>
</template>

<script>
import UploadModal from "./uploadModal.vue";

export default {
  name: "ImageUploader",
  components: { UploadModal },

  props: {
    value: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      showModal: false,
      previews: []
    };
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        // bersihkan URL lama
        this.previews = [];
        setTimeout(() => {
            this.previews = val
        }, 200);

        // this.previews.forEach(u => URL.revokeObjectURL(u));
        // console.log(val)
      }
    }
  },

  beforeDestroy() {
    this.previews.forEach(u => URL.revokeObjectURL(u));
  },

  methods: {
    openImage(url) {
      window.open(url, "_blank");
    },

    openModal() {
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
    },

    updateValue(blobs) {
      this.$emit("input", blobs);
    },

    remove(index) {
      const blobs = [...this.value];
      blobs.splice(index, 1);
      this.$emit("input", blobs);
      this.openModal()
    }
  }
};
</script>

<style scoped>
.image-uploader {
  margin-bottom: 24px;
}

.btn-upload {
  padding: 8px 14px;
  border-radius: 6px;
  border: 1px solid #409eff;
  background: #409eff;
  color: #fff;
  cursor: pointer;
}

.preview-list {
  margin-top: 10px; 
  gap: 8px;
}
 
.remove-image {
  position: absolute;
  top: 0;
  right: 15px;
  display: block;
  padding: 4px 10px;
  border-radius: 0 4px 0 4px;
  background-color: #f56c6c;
  color: #fff;
  font-size: 22px;
  cursor: pointer;
  border: none;
}

.image-preview img {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 100%;
  object-fit: cover;
  cursor: zoom-in;
}

.image-preview img:hover {
  box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/views/monitoring/links/imageUpload/index.vue